import * as React from "react";

import styled from "styled-components";

interface FlagProps {
  className?: string;
  countryCode: string;
  countryName: string;
  bigFlag?: boolean;
}

export const Flag: React.FC<FlagProps> = (props) => {
  const [showTooltip, setShowTooltip] = React.useState(false);
  return (
    <Flex
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <span className={props.className} />
      <Name>{showTooltip && props.countryName}</Name>
    </Flex>
  );
};

export default styled(Flag)`
  width: ${(props) => (props.bigFlag ? "30px" : "15px")};
  height: ${(props) => (props.bigFlag ? "30px" : "15px")};
  display: block;
  //border-radius: 50%;
  background-size: cover;
  background-color: #303030;
  background-repeat: no-repeat;
  background-position: center center;
  background-image: ${(props) =>
    `url(${
      process.env.PUBLIC_URL
    }/static/flags/${props.countryCode?.toUpperCase()}.svg);`};
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const Name = styled.div`
  display: flex;
  align-items: center;
  margin-left: 3px;
`;
